import { Controller } from '@hotwired/stimulus'

// Builds a hosted-form link carrying utm_ tags, so a campaign's requests show their source in Parties.
export default class extends Controller {
  static targets = ['source', 'medium', 'campaign', 'copy', 'field']
  static values = { base: String }

  connect() {
    this.update()
  }

  update() {
    const url = new URL(this.baseValue)
    const pairs = [['utm_source', this.sourceTarget], ['utm_medium', this.mediumTarget], ['utm_campaign', this.campaignTarget]]
    for (const [key, input] of pairs) {
      const value = input.value.trim()
      if (value) url.searchParams.set(key, value)
    }
    this.copyTarget.dataset.copyToClipboardValue = url.toString()
    this.fieldTarget.value = url.toString()
  }
}
